import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import * as FA from "./../../styles/fontawesome.css.classes";
import * as style from "./../../styles/style.css.classes";
import { renderPopupModal } from "./popup";
import { bluePlanningColors, makeGradient } from "../lib/colors";
import { renderClosePopupButton } from "../pages/planning/selectionandforms";

export function helpIcon(opts: {
  title: string;
  renderHelpContents: () => HTMLElement;
}) {
  const showingHelpS = new Source(false);
  return (
    <span>
      <a onclick={() => showingHelpS.set(true)}>
        <i
          className={FA.icon_question_solid + style.icon_circle}
          style="margin-left: 4px; margin-right: 0px;"
        ></i>
      </a>
      {renderPopupModal(showingHelpS, ({ close }) => (
        <div
          className={style.panel + style.reset_text}
          style="border: 2px solid var(--grey-900);"
        >
          <div
            className={style.panel_header}
            style={`background: ${makeGradient(bluePlanningColors)}; color: ${
              bluePlanningColors.text
            }`}
          >
            {renderClosePopupButton(close)}
            <article className={style.text_with_icon}>
              <i className={FA.icon_question_solid}></i>
              <div>
                <b>{opts.title}</b>
              </div>
            </article>
          </div>

          {opts.renderHelpContents()}
        </div>
      ))}
    </span>
  );
}
